var map = {
	"./ico-bz.png": 908,
	"./ico-fb.png": 909,
	"./ico-gp.png": 910,
	"./ico-insta.png": 911,
	"./ico-pi.png": 912,
	"./ico-snapchat.png": 913,
	"./ico-t.png": 914,
	"./ico-tw.png": 915,
	"./ico-yt.png": 916
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/social_icons ^\.\/.*$
// module id = 907
// module chunks = 4